/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePresentPositionRequest
 */
export interface UpdatePresentPositionRequest {
    /**
     * 
     * @type {any}
     * @memberof UpdatePresentPositionRequest
     */
    currentStatusId: any | null;
    /**
     * 
     * @type {string}
     * @memberof UpdatePresentPositionRequest
     */
    currentStatusNotes: string | null;
}

/**
 * Check if a given object implements the UpdatePresentPositionRequest interface.
 */
export function instanceOfUpdatePresentPositionRequest(value: object): value is UpdatePresentPositionRequest {
    if (!('currentStatusId' in value) || value['currentStatusId'] === undefined) return false;
    if (!('currentStatusNotes' in value) || value['currentStatusNotes'] === undefined) return false;
    return true;
}

export function UpdatePresentPositionRequestFromJSON(json: any): UpdatePresentPositionRequest {
    return UpdatePresentPositionRequestFromJSONTyped(json, false);
}

export function UpdatePresentPositionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePresentPositionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'currentStatusId': json['currentStatusId'],
        'currentStatusNotes': json['currentStatusNotes'],
    };
}

export function UpdatePresentPositionRequestToJSON(value?: UpdatePresentPositionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currentStatusId': value['currentStatusId'],
        'currentStatusNotes': value['currentStatusNotes'],
    };
}

